/** @type {BD_CFG["game"]["tooltip"]} */
const defaultGameTooltip = {
    home_page: "",
    challenge_page: "",
    challenge_page_detail: "",
    overview_page: {
        overview: "",
        opt: {
            today: "",
            change_last_week: "",
            weekly_overview: "",
        },
        apt: {
            today: "",
            change_last_week: "",
            weekly_overview: "",
        },
        omzet: {
            today: "",
            change_last_week: "",
            weekly_overview: "",
        },
    },
};

/** @type {any} Localized from PHP; may be partial before init. */
const rawGame = window.CFG?.game;

/**
 * @type {BD_CFG}
 */
const CONFIG = {
    ajaxURL: window.CFG?.ajaxURL ?? "",
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    homeURL: window.CFG?.homeURL ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    user: window.CFG?.user ?? {
        id: window.CFG?.user?.id ?? 0,
    },
    game: {
        ...rawGame,
        pages: rawGame?.pages ?? [],
        current_page: rawGame?.current_page ?? "",
        tooltip: rawGame?.tooltip ?? defaultGameTooltip,
    },
    isAuth: window.CFG?.isAuth ?? 0,
    nonce: window.CFG?.nonce ?? "",
};

export default CONFIG;
